/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  InventoryItem,
  InventoryItemCreateInput,
  InventoryItemUpdateInput,
  InventoryItemsList,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError,
  VehicleInventoryItemsParams
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Vehicle Inventory Item
 */
export const createVehicleInventoryItem = (
    vehicleId: MaybeRefOrGetter<string>,
    inventoryItemCreateInput: MaybeRefOrGetter<InventoryItemCreateInput>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
inventoryItemCreateInput = toValue(inventoryItemCreateInput);

      return axiosClient<InventoryItem>(
      {url: `/vehicles/${vehicleId}/inventory/items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inventoryItemCreateInput, signal
    },
      );
    }




export const getCreateVehicleInventoryItemMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicleInventoryItem>>, TError,{vehicleId: string;data: InventoryItemCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVehicleInventoryItem>>, TError,{vehicleId: string;data: InventoryItemCreateInput}, TContext> => {

const mutationKey = ['createVehicleInventoryItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVehicleInventoryItem>>, {vehicleId: string;data: InventoryItemCreateInput}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  createVehicleInventoryItem(vehicleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVehicleInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof createVehicleInventoryItem>>>
    export type CreateVehicleInventoryItemMutationBody = InventoryItemCreateInput
    export type CreateVehicleInventoryItemMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Create Vehicle Inventory Item
 */
export const useCreateVehicleInventoryItem = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicleInventoryItem>>, TError,{vehicleId: string;data: InventoryItemCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createVehicleInventoryItem>>,
        TError,
        {vehicleId: string;data: InventoryItemCreateInput},
        TContext
      > => {
      return useMutation(getCreateVehicleInventoryItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Vehicle Inventory Items List
 */
export const vehicleInventoryItems = (
    vehicleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<VehicleInventoryItemsParams>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
params = toValue(params);

      return axiosClient<InventoryItemsList>(
      {url: `/vehicles/${vehicleId}/inventory/items`, method: 'GET',
        params, signal
    },
      );
    }




export const getVehicleInventoryItemsQueryKey = (vehicleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<VehicleInventoryItemsParams>,) => {
    return [
    'vehicles',vehicleId,'inventory','items', ...(params ? [params] : [])
    ] as const;
    }


export const getVehicleInventoryItemsQueryOptions = <TData = Awaited<ReturnType<typeof vehicleInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(vehicleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<VehicleInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleInventoryItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehicleInventoryItemsQueryKey(vehicleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehicleInventoryItems>>> = ({ signal }) => vehicleInventoryItems(vehicleId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(vehicleId) !== null && toValue(vehicleId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehicleInventoryItems>>, TError, TData>
}

export type VehicleInventoryItemsQueryResult = NonNullable<Awaited<ReturnType<typeof vehicleInventoryItems>>>
export type VehicleInventoryItemsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Vehicle Inventory Items List
 */

export function useVehicleInventoryItems<TData = Awaited<ReturnType<typeof vehicleInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 vehicleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<VehicleInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleInventoryItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehicleInventoryItemsQueryOptions(vehicleId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Vehicle Inventory Item
 */
export const destroyVehicleInventoryItem = (
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/vehicles/${vehicleId}/inventory/items/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyVehicleInventoryItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleInventoryItem>>, TError,{vehicleId: string;id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleInventoryItem>>, TError,{vehicleId: string;id: string}, TContext> => {

const mutationKey = ['destroyVehicleInventoryItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyVehicleInventoryItem>>, {vehicleId: string;id: string}> = (props) => {
          const {vehicleId,id} = props ?? {};

          return  destroyVehicleInventoryItem(vehicleId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyVehicleInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof destroyVehicleInventoryItem>>>

    export type DestroyVehicleInventoryItemMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Delete Vehicle Inventory Item
 */
export const useDestroyVehicleInventoryItem = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleInventoryItem>>, TError,{vehicleId: string;id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyVehicleInventoryItem>>,
        TError,
        {vehicleId: string;id: string},
        TContext
      > => {
      return useMutation(getDestroyVehicleInventoryItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Vehicle Inventory Item
 */
export const updateVehicleInventoryItem = (
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    inventoryItemUpdateInput: MaybeRefOrGetter<InventoryItemUpdateInput>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
id = toValue(id);
inventoryItemUpdateInput = toValue(inventoryItemUpdateInput);

      return axiosClient<InventoryItem>(
      {url: `/vehicles/${vehicleId}/inventory/items/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: inventoryItemUpdateInput, signal
    },
      );
    }




export const getUpdateVehicleInventoryItemMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleInventoryItem>>, TError,{vehicleId: string;id: string;data: InventoryItemUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVehicleInventoryItem>>, TError,{vehicleId: string;id: string;data: InventoryItemUpdateInput}, TContext> => {

const mutationKey = ['updateVehicleInventoryItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVehicleInventoryItem>>, {vehicleId: string;id: string;data: InventoryItemUpdateInput}> = (props) => {
          const {vehicleId,id,data} = props ?? {};

          return  updateVehicleInventoryItem(vehicleId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVehicleInventoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateVehicleInventoryItem>>>
    export type UpdateVehicleInventoryItemMutationBody = InventoryItemUpdateInput
    export type UpdateVehicleInventoryItemMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Update Vehicle Inventory Item
 */
export const useUpdateVehicleInventoryItem = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleInventoryItem>>, TError,{vehicleId: string;id: string;data: InventoryItemUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateVehicleInventoryItem>>,
        TError,
        {vehicleId: string;id: string;data: InventoryItemUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateVehicleInventoryItemMutationOptions(options), queryClient);
    }
